import React, { useEffect, useState, useRef } from 'react'
import { Col, Button, Modal, Form, Input, Card } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
import {
  getPermissionList,
  getRoleSearch,
  saveRole,
  updateRole,
  getRoleDetail
} from '@/services/RoleManagement/RoleManagement'
import { formatMessage, defaultRoleList, handleChange } from '@/utils/common'
import { messageModal } from '@/utils/modalUtils'
import _ from 'lodash'
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 }
  }
}
const initDataFrom = {
  roleName: '',
  roleDescription: ''
}
// 缓存编辑那条数据，用于判断是不是admin
let editObj = { ...initDataFrom }
const RoleManagement = () => {
  let commonStore = useSelector(state => state.commonStore)
  let formRef = useRef(null)
  const [initForm] = Form.useForm()
  const [tableList, setTableList] = useState([])
  const [tablePermissionList, setTablePermissionList] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [visibleFlag, setVisibleFlag] = useState(false)
  const [okButtonDisabled, setOkButtonDisabled] = useState(true)
  const [queryFlag, setQueryFlag] = useState(false)
  let searchListInit = [
    {
      type: 'input',
      label: 'languageObj.roleManagementLocale.roleName',
      key: 'roleName',
      initialValues: '',
      spans: {
        xl: 6,
        xxl: 6
      }
    }
  ]
  const [dataFrom, setDataFrom] = useState(initDataFrom)
  const tableColumns = [
    {
      title: formatMessage('languageObj.roleManagementLocale.roleName'),
      dataIndex: 'roleName',
      width: 100,
      render: (text, record) => {
        return (
          <div
            className="link_name"
            onClick={() => {
              addAndEdit(record)
            }}
          >
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage('languageObj.roleManagementLocale.roleDescription'),
      dataIndex: 'roleDescription',
      width: 100,
      render: text => {
        return <div>{text}</div>
      }
    }
  ]
  const tableColumnsPermission = [
    {
      title: formatMessage('languageObj.roleManagementLocale.category'),
      dataIndex: 'category',
      width: 50,
      render: text => {
        return <div>{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.roleManagementLocale.permissionName'),
      dataIndex: 'permissionName',
      width: 200,
      render: text => {
        return <div>{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.roleManagementLocale.permissionDescription'),
      dataIndex: 'permissionDescription',
      width: 200,
      render: text => {
        return <div>{text}</div>
      }
    }
  ]
  useEffect(() => {
    searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  useEffect(() => {
    getPermissionListFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    let okButtonFlag = selectedRowKeys.length === 0 || !dataFrom.roleName
    setOkButtonDisabled(okButtonFlag)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataFrom, selectedRowKeys])
  const getPermissionListFun = () => {
    let ls = []
    for (let index = 0; index < commonStore.roles.length; index++) {
      const element = commonStore.roles[index]
      if (defaultRoleList.includes(element)) {
        ls.push(element)
      }
    }
    let params = ls
    getPermissionList(params).then(res => {
      setTablePermissionList(res.resultData.records)
    })
  }
  const searchDataBtn = () => {
    setQueryFlag(!queryFlag)
  }
  const searchDataFun = () => {
    setSelectedRowKeys([])
    let info = {}
    info = (formRef.current && formRef.current.getValue()) || {}
    const params = {
      ...info
    }
    getRoleSearch(params).then(res => {
      const dt = res.resultData.records
      setTableList(dt)
    })
  }
  const searchClearDataBtn = () => {
    formRef && formRef.current.clearForm()
    setQueryFlag(!queryFlag)
  }
  const addAndEdit = record => {
    setVisibleFlag(true)
    initForm.resetFields()
    if (record) {
      let params = {
        roleId: record.id
      }
      editObj = _.cloneDeep(record)
      setDataFrom(record)
      initForm.setFieldsValue(record)
      getRoleDetail(params).then(res => {
        let permissionList = res.resultData.permissionList
        let resLs = permissionList.map(item => item.id)
        setSelectedRowKeys(resLs)
      })
    } else {
      editObj = _.cloneDeep(initDataFrom)
      setDataFrom(initDataFrom)
      setSelectedRowKeys([])
      initForm.setFieldsValue(initDataFrom)
    }
  }
  const handleUserOk = () => {
    initForm
      .validateFields()
      .then(values => {
        let params = {
          id: dataFrom.id,
          roleDescription: values.roleDescription,
          roleName: values.roleName,
          permissionIdList: selectedRowKeys
        }
        if (params.id) {
          updateRole(params)
            .then(() => {
              messageModal('success', { content: formatMessage('languageObj.commonLocale.success') })
              handleUserCancel()
              setQueryFlag(!queryFlag)
            })
            .catch(err => {
              let str = ''
              switch (err.errorcode) {
                case '702':
                  str = formatMessage('languageObj.roleManagementLocale.error702')
                  break

                default:
                  str = formatMessage('languageObj.httpLocale.requestError')
                  break
              }
              messageModal('error', { content: str })
            })
        } else {
          delete params.id
          saveRole(params)
            .then(() => {
              messageModal('success', { content: formatMessage('languageObj.commonLocale.success') })
              handleUserCancel()
              setQueryFlag(!queryFlag)
            })
            .catch(err => {
              let str = ''
              switch (err.errorcode) {
                case '702':
                  str = formatMessage('languageObj.roleManagementLocale.error702')
                  break

                default:
                  str = formatMessage('languageObj.httpLocale.requestError')
                  break
              }
              messageModal('error', { content: str })
            })
        }
      })
      .catch(errorInfo => {
        console.log(errorInfo)
      })
  }
  const handleUserCancel = () => {
    setVisibleFlag(false)
  }
  const checkPermissionByRole = () => {
    // 不区分大小写
    return defaultRoleList.includes(editObj.roleName.toLowerCase()) && editObj.id
  }
  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const rowSelection = {
    // columnWidth: 20,
    selectedRowKeys,
    getCheckboxProps: () => ({
      // disabled: checkPermissionByRole()
    }),
    onChange: onSelectChange
  }
  return (
    <div>
      <Card>
        <div className="search-bar">
          <SearchBar ref={formRef} searchList={searchListInit}>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={8}
              xl={6}
              xxl={6}
              className="right_search"
              style={{ justifyContent: 'flex-end' }}
            >
              <Button icon={<SearchOutlined />} type="primary" onClick={searchDataBtn}>
                {formatMessage('languageObj.commonLocale.search')}
              </Button>
              <Button onClick={searchClearDataBtn}>{formatMessage('languageObj.commonLocale.clear')}</Button>
            </Col>
          </SearchBar>
        </div>
      </Card>
      <Card className="mt15">
        <div className="content-container">
          <div className="mb15">
            <Button type="primary" onClick={() => addAndEdit()}>
              {formatMessage('languageObj.commonLocale.addNew')}
            </Button>
          </div>
          <AntdTable dataSource={tableList} columns={tableColumns} />
        </div>
      </Card>
      <Modal
        open={visibleFlag}
        maskClosable={false}
        centered={true}
        className="nike_modal"
        width="70%"
        okButtonProps={{
          disabled: okButtonDisabled
        }}
        title={
          dataFrom.id
            ? formatMessage('languageObj.commonLocale.edit')
            : formatMessage('languageObj.commonLocale.addNew')
        }
        onOk={handleUserOk}
        onCancel={handleUserCancel}
        // {...(checkPermissionByRole() ? { footer: null } : {})}
      >
        <Form form={initForm} {...formItemLayout} layout="inline">
          <Form.Item
            style={{
              width: '45%',
              margin: 0,
              padding: '0 10px'
            }}
            label={formatMessage('languageObj.roleManagementLocale.roleName')}
            name="roleName"
            rules={[
              {
                required: true,
                validator: (_, value) => {
                  if (!value) {
                    return Promise.reject(
                      new Error(
                        formatMessage('languageObj.roleManagementLocale.roleName') +
                          formatMessage('languageObj.commonLocale.isRequired')
                      )
                    )
                  } else {
                    return Promise.resolve()
                  }
                }
              }
            ]}
            initialValue={dataFrom.roleName}
          >
            <Input
              allowClear
              value={dataFrom.roleName}
              onChange={e => handleChange(e, { setState: setDataFrom, state: dataFrom, key: 'roleName' })}
              disabled={checkPermissionByRole() ? true : false}
              placeholder={formatMessage('languageObj.commonLocale.placeholderInput')}
            />
          </Form.Item>
          <Form.Item
            style={{
              width: '55%',
              margin: 0,
              padding: '0 10px'
            }}
            labelCol={{
              xs: { span: 24 },
              sm: { span: 8 }
            }}
            wrapperCol={{
              xs: { span: 24 },
              sm: { span: 16 }
            }}
            label={formatMessage('languageObj.roleManagementLocale.roleDescription')}
            name="roleDescription"
            initialValue={dataFrom.roleDescription}
          >
            <Input
              allowClear
              disabled={checkPermissionByRole() ? true : false}
              onChange={e => handleChange(e, { setState: setDataFrom, state: dataFrom, key: 'roleDescription' })}
              placeholder={formatMessage('languageObj.commonLocale.placeholderInput')}
            />
          </Form.Item>
        </Form>
        <div className="mt15">
          <AntdTable
            rowKey={record => record.id}
            rowSelection={rowSelection}
            dataSource={tablePermissionList}
            columns={tableColumnsPermission}
            scroll={{
              y: '50vh'
            }}
          />
        </div>
      </Modal>
    </div>
  )
}
export default RoleManagement
